<template>
  <div class="contact-container">
    <h1 class="title">Dove siamo</h1>
    <div class="map-block">

      <div class="places-list">
        <div :key="sede.id" v-for="(sede, index) in sedi" class="places-item">
          <div class="places-name" @click="show(sede)" @mouseover="mouseOver(index)" @mouseleave="mouseLeave(index)">{{
            sede.title }}
          </div>
        </div>
      </div>

      <transition name="fade">
        <div class="popup" v-if="overlay">
          <div class="popup-wrapper">
            <div class="sede-img-container">
              <img class="sede-img" :src="SedeImg">
            </div>

            <div class="sede-text-container">
              <div class="sede-title">
                <img class="sede-logo" :src="SedeLogo"/>
                <div class="sede-nome" v-html="SedeNome"></div>
              </div>

              <div class="sede-indirizzo-container">
                <div class="sede-indirizzo" v-html="SedeIndirizzo"></div>
                <div class="sede-cap" v-html="SedeCap"></div>
                <div class="sede-city-prov">
                  <span class="sede-city" v-html="SedeCity"></span>
                  (<span class="sede-prov" v-html="SedeProv"></span>)
                </div>
              </div>
            </div>

            <a @click="hide" class="close-popup">Chiudi</a>
          </div>
        </div>
      </transition>

      <div class="gmap" id="mapsearch">

      </div>

    </div>
    <ContactForm></ContactForm>
  </div>
</template>

<script>

  import ContactForm from '@/components/ContactForm.vue'
  import Waterwheel from "waterwheel"
  import jsonapiParse from "jsonapi-parse";
  import GoogleMapsLoader from 'google-maps'

  const waterwheel = new Waterwheel(
      {
        base: process.env.VUE_APP_HOST_URL,
        jsonapiPrefix: 'api',
        timeout: 3000,
        accessCheck: false
      }
  );
  const query = {
    filter: {
      status: 1
    },
    include: 'immagine, logo',
    sort: 'ordinamento'
  }
  export default {
    name: 'Sedi',
    components: {
      ContactForm
    },
    metaInfo: {
      title: 'Contatti',
      titleTemplate: '%s - Gabiano Holding',
    },
    data() {
      return {
        map: null,
        sedi: [],
        center: {lat: 42.2936194, lng: 13.0229644},
        markers: [],
        places: [],
        currentPlace: null,
        overlay: false,
        SedeLogo: '',
        SedeNome: '',
        SedeIndirizzo: '',
        SedeCap: '',
        SedeCity: '',
        SedeProv: '',
        SedeImg: '',
        mapStyle: {
          mapTypeControl: false,
          zoomControl: false,
          scaleControl: false,
          scrollwheel: false,
          streetViewControl: false,
          fullscreenControl: false,
          draggable: false,
          styles: [
            {
              "featureType": "administrative",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "landscape",
              "elementType": "labels",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "landscape.man_made",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "landscape.natural",
              "elementType": "geometry.fill",
              "stylers": [
                {
                  "color": "#e30613"
                },
                {
                  "visibility": "on"
                }
              ]
            },
            {
              "featureType": "landscape.natural.landcover",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#e30613"
                }
              ]
            },
            {
              "featureType": "landscape.natural.landcover",
              "elementType": "geometry.fill",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "landscape.natural.landcover",
              "elementType": "labels",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "landscape.natural.terrain",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "poi",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "road",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "transit",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#f2f2f2"
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "labels",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            }
          ]
        },
      }
    },
    created() {
      // Load Sedi.
      waterwheel.jsonapi.get('node/sede', query).then(sedi => {
        this.sedi = jsonapiParse.parse(sedi).data;
        //  this.sediMarker();
        this.map = this.createMap()
      })

    },
    mounted() {
      //this.geolocate();

      /*if(window.innerWidth < 640) {
        this.$refs.gmap.zoom = 5
      }
      else {
        this.$refs.gmap.zoom = 6
      }*/

    },
    methods: {

      createMap() {
        GoogleMapsLoader.KEY = 'AIzaSyC5hvcODjCH2cYJdvtsTsVXx5frjl8cd5s'
        GoogleMapsLoader.VERSION = '3.36'

        let vuemap = null
        let vuemarkers = this.markers
        let vuesedi = this.sedi
        let mapStyle = this.mapStyle
        let vueobj = this

        GoogleMapsLoader.load(function (google) {
        //  if (vuemap === null) {
            vuemap = new google.maps.Map(document.getElementById('mapsearch'), mapStyle)

       //   }
          let map = vuemap;

          let bounds = new google.maps.LatLngBounds();
          let marker;
          let markers = Array();

          //   this.markers = null;
          markers = vuemarkers;
          for (let i = 0; i < markers.length; i++) {
            markers[i].setMap(null);
          }
          markers = [];
          let index = 0;

          vuesedi.forEach(sede => {

            let lat = parseFloat(sede.geolocation.lat);
            let lng = parseFloat(sede.geolocation.lng);
            let markerLatLng = {lat: lat, lng: lng};
            let title = sede.title;

            //
            let ico = {
              url: require('../assets/images/marker.png'),
              size: new google.maps.Size(46, 46),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(23, 23)
            };



            // Build marker.
            marker = new google.maps.Marker({
              position: markerLatLng,
              map: map,
              animation: google.maps.Animation.DROP,
              title: title,
              icon: ico,
            });
            // Click.
            marker.addListener('click', function () {
              vueobj.show(sede)
            });
            // Mouse over.
            marker.addListener('mouseover', function () {
              this.setAnimation(google.maps.Animation.BOUNCE);
              this.setAnimation(null);
            });
            // Mouse out.
            marker.addListener('mouseout', function () {
              this.setAnimation(null);
            });
            // Focus listener.
            marker.addListener('markfocus', function () {
              this.setAnimation(google.maps.Animation.BOUNCE);
              this.setAnimation(null);
            });
            // Exit Focus listener.
            marker.addListener('markerNoFocus', function () {
              this.setAnimation(null);
            });

            // Push marker.
            markers.push(marker);
            index++
          });
          vuemarkers = markers;

          if (markers.length > 0) {
            for (let i = 0; i < markers.length; i++) {
              bounds.extend(markers[i].getPosition());
            }
            map.fitBounds(bounds);
          }

          vueobj.markers = markers
          vueobj.map = vuemap
        });

      },

      sediMarker() {
        this.sedi.forEach((sede) => {
          this.addMarker(sede.geolocation.lat, sede.geolocation.lng);
        })

      },
      addMarker(latValue, lngValue) {
        //  if (this.currentPlace) {
        const marker = {
          lat: latValue,
          lng: lngValue
        };
        this.markers.push({
          position: marker
        });
        //        this.places.push(this.currentPlace);
        //     this.center = marker;
        //    this.currentPlace = null;
        //    }
      },
      geolocate: function () {
        navigator.geolocation.getCurrentPosition(position => {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
        });
      },
      show(sede) {
        this.overlay = true;
        this.SedeImg = process.env.VUE_APP_HOST_URL + sede.immagine.url;
        this.SedeLogo = process.env.VUE_APP_HOST_URL + sede.logo.url;
        this.SedeNome = sede.title;
        this.SedeIndirizzo = sede.indirizzo.address_line1
        this.SedeCap = sede.indirizzo.postal_code;
        this.SedeCity = sede.indirizzo.locality;
        this.SedeProv = sede.indirizzo.administrative_area;
        //  this.stopScroll = true;
        //     this.stopWindowScrollPosition = $(window).scrollTop();
      },
      hide() {
        this.overlay = false;
        //     this.stopScroll = 0;
      },

      mouseOver: function (index) {
        google.maps.event.trigger(this.markers[index], 'markfocus');
      },
      mouseLeave: function (index) {
        google.maps.event.trigger(this.markers[index], 'markerNoFocus');
      },
    }

  }
</script>
